// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56533205","453":"49f7f260","455":"7bd8cf0a","977":"29549fd3"}[chunkId] + ".chunk.js";
};